import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, Portal, Text, TextInput } from "react-native-paper";
import { StyleSheet } from "react-native";
import { KeyboardAvoidingView } from "react-native-keyboard-controller";

interface CreateFolderDialogProps {
  visible: boolean;
  folderName: string;
  error: string;
  mode?: "create" | "edit";
  onChangeName: (name: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function CreateFolderDialog({
  visible,
  folderName,
  error,
  mode = "create",
  onChangeName,
  onConfirm,
  onCancel,
}: CreateFolderDialogProps) {
  const { t } = useTranslation();
  const isEditing = mode === "edit";

  return (
    <Portal>
      <KeyboardAvoidingView behavior="padding">
        <Dialog visible={visible} onDismiss={onCancel}>
          <Dialog.Title>
            {isEditing ? t("Rename Folder") : t("Create New Folder")}
          </Dialog.Title>
          <Dialog.Content>
            <TextInput
              label={t("Folder Name")}
              value={folderName}
              onChangeText={onChangeName}
              error={!!error}
              autoFocus
            />
            {error ? <Text style={styles.errorText}>{error}</Text> : null}
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={onCancel}>{t("Cancel")}</Button>
            <Button onPress={onConfirm}>
              {isEditing ? t("Save") : t("Create")}
            </Button>
          </Dialog.Actions>
        </Dialog>
      </KeyboardAvoidingView>
    </Portal>
  );
}

const styles = StyleSheet.create({
  errorText: {
    color: "#B00020",
    fontSize: 12,
    marginTop: 4,
  },
});
